import { type ClassifiedSeller } from '@/types';

const JSON_LD_UNSAFE_CHARS: Record<string, string> = {
    '<': '\\u003c',
    '>': '\\u003e',
    '&': '\\u0026',
    '\u2028': '\\u2028',
    '\u2029': '\\u2029',
};

/**
 * Serializa um schema para <script type="application/ld+json">.
 * O JSON.stringify não escapa "<", então um texto vindo do usuário (ex.: título "</script><img onerror=...>")
 * fecharia a tag do script e injetaria HTML. Os escapes \uXXXX são lidos de volta como o mesmo caractere pelo
 * Google e por qualquer parser JSON, então o dado estruturado não muda.
 */
export const toJsonLd = (schema: unknown): string => {
    return (JSON.stringify(schema) ?? '').replace(/[<>&\u2028\u2029]/g, (char) => JSON_LD_UNSAFE_CHARS[char]);
};

/**
 * "seller" da Offer do anúncio. A empresa usa o mesmo @id do LocalBusiness publicado no perfil,
 * para o Google e as IAs ligarem anúncio e empresa; o particular só tem o nome abreviado.
 */
export const buildSellerSchema = (seller?: ClassifiedSeller | null) => {
    if (!seller) {
        return undefined;
    }

    if (seller.type === 'empresa') {
        return {
            '@type': 'LocalBusiness',
            '@id': `${seller.profile_url}#localbusiness`,
            name: seller.name,
            url: seller.profile_url,
        };
    }

    return { '@type': 'Person', name: seller.name };
};
